"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAddressResultsAddressToJSON = exports.SearchAddressResultsAddressFromJSONTyped = exports.SearchAddressResultsAddressFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function SearchAddressResultsAddressFromJSON(json) {
    return SearchAddressResultsAddressFromJSONTyped(json, false);
}
exports.SearchAddressResultsAddressFromJSON = SearchAddressResultsAddressFromJSON;
function SearchAddressResultsAddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'additional': json['additional'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'countryCode': json['countryCode'],
        'gender': !(0, runtime_1.exists)(json, 'gender') ? undefined : (0, _1.GenderFromJSON)(json['gender']),
        'addressName': !(0, runtime_1.exists)(json, 'addressName') ? undefined : json['addressName'],
        'primaryPhoneNumber': !(0, runtime_1.exists)(json, 'primaryPhoneNumber') ? undefined : json['primaryPhoneNumber'],
        'secondaryPhoneNumber': !(0, runtime_1.exists)(json, 'secondaryPhoneNumber') ? undefined : json['secondaryPhoneNumber'],
        'honorific': !(0, runtime_1.exists)(json, 'honorific') ? undefined : json['honorific'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'birthName': !(0, runtime_1.exists)(json, 'birthName') ? undefined : json['birthName'],
    };
}
exports.SearchAddressResultsAddressFromJSONTyped = SearchAddressResultsAddressFromJSONTyped;
function SearchAddressResultsAddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'additional': value.additional,
        'street': value.street,
        'houseNumber': value.houseNumber,
        'zipCode': value.zipCode,
        'city': value.city,
        'countryCode': value.countryCode,
        'gender': (0, _1.GenderToJSON)(value.gender),
        'addressName': value.addressName,
        'primaryPhoneNumber': value.primaryPhoneNumber,
        'secondaryPhoneNumber': value.secondaryPhoneNumber,
        'honorific': value.honorific,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'birthName': value.birthName,
    };
}
exports.SearchAddressResultsAddressToJSON = SearchAddressResultsAddressToJSON;
//# sourceMappingURL=SearchAddressResultsAddress.js.map